import config from 'config';
import _ from 'lodash';
import { loadMediaForArticles } from 'modules/Common/reducers/media';

const LOAD = 'common/more-news/LOAD';
const LOAD_SUCCESS = 'common/more-news/LOAD_SUCCESS';
const LOAD_SUCCESS_REFRESH = 'common/more-news/LOAD_SUCCESS_REFRESH';
const LOAD_FAIL = 'common/more-news/LOAD_FAIL';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.basketPath]: {
          ...state[action.basketPath],
          loading: true,
          articles: (state[action.basketPath] && state[action.basketPath].articles) || []
        }
      };
    case LOAD_SUCCESS: {

      const currentSummaries = state[action.basketPath] && state[action.basketPath].articles;
      const summaries = currentSummaries.concat(action.result.articles);

      const sortAndUnique = a => a.priority;
      const sortedAndUnique = _.sortedUniqBy(_.sortBy(summaries, [ sortAndUnique ]), sortAndUnique);

      return {
        ...state,
        [action.basketPath]: {
          ...state[action.basketPath],
          loading: false,
          loaded: true,
          articles: sortedAndUnique,
          path: action.result.basket_path,
          name: action.result.basket_name,
          title: action.result.basket_title
        }
      };
    }
    case LOAD_SUCCESS_REFRESH:
      return {
        ...state,
        [action.basketPath]: {
          ...state[action.basketPath],
          loading: false,
          loaded: true,
          articles: action.result.articles,
          path: action.result.basket_path,
          name: action.result.basket_name,
          title: action.result.basket_title
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.basketPath]: {
          ...state[action.basketPath],
          loading: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

function generateBasketPath(basketPath) {
  let newBasketPath = "sl" + basketPath;
  if (basketPath == "/") {
    newBasketPath = newBasketPath + "home"
  }
  return newBasketPath;
}

export function isLoaded(globalState, basketPath) {
  return globalState.common.morenews
      && globalState.common.morenews[basketPath]
      && globalState.common.morenews[basketPath].loaded;
}

export function load(basketPath, limit, offset, refresh) {
  return loadByPath(basketPath, limit, offset, refresh);
}

export function loadByPath(basketPath, limit, offset, refresh) {
  return _loadData({
    key: "basketPath",
    value: basketPath
  }, {limit, offset, refresh});
}

export function loadById(basketId, limit, offset, refresh) {
  return _loadData({
    key: "basketId",
    value: basketId
  }, {limit, offset, refresh});
}

export function loadByQuery(query, limit, offset, refresh) {
  return _loadData(query, {limit, offset, refresh});
}

export function loadMostRead(basketPath) {
  let query = {};

  if (basketPath) {
    query = {
      key: "basketPath",
      value: basketPath
    };
  }

  return _loadData(query, {
    mostRead: true
  });
}

const _mostReadKey = (path = "all-articles") => `${path}::MOST_READ`;

function _loadData({key, value} = {}, {limit = 5, offset = 0, refresh = false, mostRead = false}) {
  const params = {
    limit,
    offset
  }

  if (key == "basketPath") {
    params[key] = generateBasketPath(value);
  }
  else if (value) {
    params[key] = value;
  }

  let storageKey = value;

  if (mostRead) {
    storageKey = _mostReadKey(value);
    params.orderBy = "MOST_READ";
  }

  return {
    // Exact same data structure just slightly different logic in action based on a refresh or load morenews.
    // Had a problem when an article was removed and the state was keeping hold of it.
    types: [LOAD, refresh ? LOAD_SUCCESS_REFRESH : LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.common.loadArticleSummary, {params}),
    // store by path or ID, which ever the data was requested by
    // OK because paths always start with "sl/" and IDs never do
    // also path is for default baskets, and ID for custom ones, so there will be no duplication
    basketPath: storageKey
  };
}

export function connectMoreNews(state) {
  return {
    news: state.common.morenews
  }
}

export function asyncConnectMostRead(basketPath) {
  return [{
    dispatch: () => loadMostRead(basketPath),
    state: ({
      common: {
        morenews: {
          [_mostReadKey(basketPath)]: {
            articles
          } = {}
        } = {}
      } = {}
    }) => ({
      mostread: articles
    }),
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }];
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/morenews.js